export function walkWidgetConfigTree(config, widgets, callback, param) {
    const widgetMap = {};
    for (const widget of widgets) {
        widgetMap[widget.type] = widget;
    }
    walkWidgetConfigTreeRecursive(config, widgetMap, callback, param);
}
function walkWidgetConfigTreeRecursive(config, widgetMap, callback, param) {
    const widget = widgetMap[config.type];
    if (widget) {
        param = callback(config, widget, param);
        if (widget.childConfigs) {
            for (const childConfig of widget.childConfigs(config)) {
                walkWidgetConfigTreeRecursive(childConfig, widgetMap, callback, param);
            }
        }
    }
}
